import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormControlIcon]',
  standalone: true,
})
export class FormControlIconDirective {}
